import { render, staticRenderFns } from "./Ripple.vue?vue&type=template&id=15a1f330&scoped=true&"
import script from "./Ripple.vue?vue&type=script&lang=js&"
export * from "./Ripple.vue?vue&type=script&lang=js&"
import style0 from "./Ripple.vue?vue&type=style&index=0&id=15a1f330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a1f330",
  null
  
)

export default component.exports